var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSigninPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "682.646 481.566 18.423 22.868",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #868686;\n        fill-rule: evenodd;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "phone",
    transform: "matrix(0.966, -0.259, 0.259, 0.966, 930.385, 461.18)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    className: "cls-1",
    d: "M2.039.724v0s-4.016,4.222-.774,11.466S10.879,20,10.879,20a4.189,4.189,0,0,0,2.836-2.729L8.931,14.108l-1.709.637A9.661,9.661,0,0,1,3.729,6.872l1.5-.824L5.952.359A4.174,4.174,0,0,0,2.039.724Z",
    transform: "translate(-245.493 -41)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSigninPhone);
export default __webpack_public_path__ + "static/media/signin_phone.540214400921fe3dcc5986e65442bc7e.svg";
export { ForwardRef as ReactComponent };